<template>
	<div>
		<div class="noprint">Print stuff <button class="btn btn-primary" @click="print()">Print</button></div>

		<div class="qr-container d-flex flex-wrap" v-if="classObj">
			<div class="qr-element " v-for="student in students" :key="student.id">
				<div class="d-flex w-100">
					<div class="flex-grow">
						<h5 class="underline">OSCAR Classroom</h5>
						<br />
						<br />
						<h4 class="name">{{ student.first_name }}<br />{{ student.last_name }}</h4>
					</div>
					<div class="qr">
						<qrcode :value="urlBase + student.id" :options="qrOpts"></qrcode>
					</div>
				</div>
				<span class="qr-footer">{{ urlBase }}{{ student.id }}</span>
			</div>
		</div>
	</div>
	<!-- <mzfooter></mzfooter> -->
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@page {
	margin: 0 0 0 0;
	size: 1020px 1320px;
}
@media print {
	.break {
		page-break-after: always;
	}
	.noprint {
		display: none;
	}
	body {
		margin: 0;
	}
	/* .qr-container {
		width: 215.9mm;
	}
	.qr-element {
		 height: 55.88mm;
	} */
}

@page :left {
	margin-left: 0cm;
}

@page :right {
	margin-left: 0cm;
}
/* #app {
	height: default !important;
} */
/* .h100 {
	height: default !important;
} */
/* .fixed-content {
	height: default !important;
} */
/* .app {
	max-height: default !important;
} */
/* body {
	height: default !important;
	background-color: white;
	color: black;
} */
/* .app-content {
	background-color: white;
} */
.underline {
	text-decoration: underline;
}
.name {
	text-align: center;
	text-transform: uppercase;
}
/* .qr{
	width:200px;
	height:200px;
} */
.qr-container {
	margin: auto;
	width: 1020px;
	/* margin:-20px; */
	/* width: 215.9mm; */

	background-color: white;
}
.qr-element:nth-child(odd) {
	border-right: dotted 1px lightgrey;
}
.qr-footer {
	color: grey;
	font-size: 10px;
}
.qr-element {
	width: 50%;
	padding: 20px;
	border-bottom: dotted 1px lightgrey;
	height: 264px;
	/* border-bottom:dotted 2px lightgrey; */

	/* display: inline; */
}
</style>

<script>
import ClassService from "@/services/ClassService";
import StudentService from "@/services/StudentService";
import ContentAreaService from "@/services/ContentAreaService";
import GradeService from "@/services/GradeService";
import ReportingService from "@/services/ReportingService";
import ResourceService from "@/services/ResourceService";
import FileService from "@/services/FileService";
import ValidationPatternService from "@/services/ValidationPatternService";
import Notie from "@/services/NotieService";

import ConfigStudentSearch from "@/components/ConfigStudentSearch";
import ConfigAssessmentSearch from "@/components/ConfigAssessmentSearch";
import RichText from "@/components/RichText";
import draggable from "vuedraggable";
import $ from "jquery";
import BB from "bluebird";
import VueQrcode from "@chenfengyuan/vue-qrcode";

console.log(VueQrcode.name);
export default {
	name: "ClassQR",

	props: ["user"],

	data() {
		return {
			classObj: null,
			students: [],
			assessments: null,
			district: null,

			deliveryID: null,
			asmtName: null,
			asmt: null,
			asmtPretest: false,
			asmtPosttest: false,
			asmtNotes: null,
			asmtNotesInit: null,
			asmtItem: null,

			areas: [],
			sAreas: null,
			grades: [],
			sGrades: null,

			asmtDeliveries: [],
			completion: [],

			studentSearch: null,
			addingStudents: [{}],
			validating: false,
			validated: false,
			allValid: false,
			adding: false,

			editStudent: null,
			editSaving: false,

			removingStudent: null,
			removing: false,

			deletingAsmt: null,
			deleteAsmtConfirm: null,

			newWork: [],
			droppingFiles: false,
			droppingFile: false,
			qrOpts: {
				width: 200
			},

			urlBase: ""
		};
	},
	components: {
		qrcode: VueQrcode
	},

	watch: {
		asmt() {
			if (this.asmt) {
				this.asmtName = this.asmt.name;
				if (this.asmt.assessment_items && this.asmt.assessment_items.length) {

				this.asmtItem = this.asmt.item
				} 
				else {
					this.asmtItem = null;
				}
			} else {
				this.asmtName = "";
				this.asmtItem = null;
			}
		},
		studentSearch() {
			if (this.studentSearch) {
				this.clearEmptyStudentRows();
				let exists = _.find(this.addingStudents, {
					id: this.studentSearch.id
				});
				if (!exists) {
					this.addingStudents.push(this.studentSearch);
					this.studentSearch = null;
				}
			}
		}
	},

	computed: {
		anyStudents() {
			let any = false;
			_.each(this.addingStudents, s => {
				if (!s.exists && (s.first_name || s.last_name || s.ref_id)) {
					any = true;
				}
			});
			return any;
		},

		sortedStudents() {
			return _.orderBy(this.students, ["last_name", "first_name"], ["asc", "asc"]);
		}
	},

	created() {
		this.loadData();
		$("body").removeClass("fixed-content");
		$("body").width(1020);
		$("body").css("margin", "auto");
	},
	methods: {
		loadData() {
			this.urlBase = location.protocol + "//" + location.host + "/#/submit/";

			return BB.props({
				class: ClassService.getClassAndAssessments(this.$route.params.classID),
				students: StudentService.listStudentsFromClass(this.$route.params.classID)
			})
				.then(resps => {
					this.classObj = resps.class.data.class;
					this.students = resps.students.data.students;
				})
				.catch(err => {
					console.log(err);
					Notie.error("Failed to load class", err);
				});
		},
		print() {
			window.print();
		},

		loadCompletionStats() {
			_.each(this.assessments, asmt => {
				_.each(asmt.deliveries, deliv => {
					let stat = _.find(this.completion, {
						assessment_id: asmt.id,
						delivery_id: deliv.id
					});
					if (stat) {
						deliv.total = this.students.length;
						deliv.uploaded = stat.uns + stat.rel + stat.res + stat.com;
						deliv.uploadedPer = ((deliv.uploaded / deliv.total) * 100).toFixed(1);
						deliv.complete = stat.com;
						deliv.completePer = ((deliv.complete / deliv.total) * 100).toFixed(1);
						deliv.difference = deliv.uploaded - deliv.complete;
						deliv.differencePer = ((deliv.difference / deliv.total) * 100).toFixed(1);
					}
				});
			});
		},

		addNewWork(file) {
			var suggestedName = file.name.split(".");
			if (suggestedName.length > 1) {
				//Pop off the extension if it exists
				suggestedName.pop();
			}
			suggestedName = suggestedName.join("");
			suggestedName = suggestedName.replace(/_/g, " ");

			this.newWork.push({
				name: suggestedName,
				file: file,
				uploading: false
			});

			console.log("___ADD NEW WORK___");
			console.log(file);
		},

		addDropFiles(event) {
			console.log("___FILE ENTER___");
			console.log(event.dataTransfer.files);
			this.droppingFiles = true;
		},

		removeDropFiles(event) {
			console.log("___FILE LEAVE___");
			console.log(event.dataTransfer.files);
			this.droppingFiles = false;
		},

		doDropFiles(event) {
			console.log("___FILE DROP___");
			console.log(event.dataTransfer.files);
			_.each(event.dataTransfer.files, file => {
				this.addNewWork(file);
			});
			this.droppingFiles = false;
		},

		openAddModal(asmt) {
			this.blankAsmt(asmt);
			$("#addAssessmentModal").modal();
		},

		openEditModal(asmt) {
			this.loadAsmt(asmt);
			$("#editAssessmentModal").modal();
		},

		loadAsmt(asmt) {
			this.asmtDeliveries = _.filter(this.classObj.deliveries, {
				assessment_id: asmt.id
			});
			_.each(this.asmtDeliveries, deliv => {
				deliv.item_notes_init = deliv.item_notes;
			});
			this.asmt = asmt;
		},

		blankAsmt() {
			this.deliveryID = null;
			this.asmt = null;
			this.asmtName = null;
			this.asmtPretest = false;
			this.asmtPosttest = false;
			this.asmtNotesInit = null;
		},

		addAsmt() {
			let delivery = {
				id: this.deliveryID,
				assessment_id: this.asmt.id,
				name: this.asmtName,
				item_notes: this.asmtNotes,
				pretest: this.asmtPretest,
				posttest: this.asmtPosttest
			};

			ClassService.saveDelivery(this.classObj.id, delivery)
				.then(resp => {
					this.loadData();
				})
				.catch(err => {
					console.log(err);
					Notie.error("Failed to save assessment", err);
				});
		},

		showDeleteAssessment(asmt) {
			this.deletingAsmt = asmt;
			this.deleteAsmtConfirm = "";
			$("#deleteAssessmentModal").modal();
		},

		deleteAssessment(asmt) {
			return ClassService.deleteDeliveriesByAssessment(this.classObj.id, asmt.id)
				.then(resp => {
					this.loadData();
					Notie.info(`${asmt.name} deleted`);
				})
				.catch(err => {
					console.log(err);
					Notie.error("Failed to delete assessment", err);
				});
		},

		saveDeliveries() {
			ClassService.saveClass(this.classObj)
				.then(resp => {
					this.loadData();
				})
				.catch(err => {
					console.log(err);
					Notie.error("Failed to save assessment", err);
				});
		},

		openResourcesDropdown(id) {
			let el = $(`#resourcesDropdown-${id}`);
			console.log(el);
			el.dropdown("toggle");
		},

		addStudentRow() {
			this.addingStudents.push({});
		},

		removeStudentRow(i) {
			this.$delete(this.addingStudents, i);

			if (this.addingStudents.length == 0) {
				this.addingStudents.push({});
			}
			this.validated = false;
			this.allValid = false;
		},

		clearEmptyStudentRows(clearAll) {
			this.addingStudents = _.filter(this.addingStudents, s => {
				return s.first_name || s.last_name || s.id || s.grade;
			});
		},

		doAddStudents() {
			this.clearEmptyStudentRows();
			_.each(this.addingStudents, student => {
				student.district_id = this.classObj.district_id;
				student.client_id = this.classObj.client_id;
			});
			ClassService.saveStudentsToClass(this.classObj.id, this.addingStudents)
				.then(resp => {
					let count = resp.data;
					Notie.info(`${count} ${count > 1 ? "students" : "student"} saved`);
					this.addingStudents = [{}];
					this.loadData().then(() => {
						$("#addStudentModal").modal("toggle");
					});
				})
				.catch(err => {
					console.log(err);
					Notie.error("Failed to save student(s)", err);
				});
		},

		importStudentRows(file) {
			if (file.type != "text/csv" && file.type != "application/vnd.ms-excel") {
				this.importingFile = null;
				notie.error("File must be CSV!");
				return;
			}

			let reader = new FileReader();
			reader.onload = e => {
				let studentsIn = FileService.CSVToArray(e.target.result);

				let students = [];
				for (var i = 1; i < studentsIn.length; i++) {
					let studentIn = studentsIn[i];
					let grade = _.find(this.grades, { name: studentIn[3] });
					grade = grade || this.grades[0];
					let student = {
						first_name: studentIn[0],
						last_name: studentIn[1],
						ref_id: studentIn[2],
						grade: grade,
						grade_id: grade.id
					};
					if (student.first_name || student.last_name || student.ref_id) {
						students.push(student);
					}
				}

				this.validateStudents(students);
			};

			reader.readAsText(file);
		},

		selectImportFile(event) {
			console.log("===CHOOSE FILE===");
			console.log(event.target.files);
			if (event.target.files[0]) {
				this.importingFile = event.target.files[0];
				this.importStudentRows(this.importingFile);
			}
		},

		addDropStudentFiles(event) {
			console.log("___FILE ENTER___");
			console.log(event.dataTransfer.files);
			this.droppingFile = true;
		},

		removeDropStudentFiles(event) {
			console.log("___FILE LEAVE___");
			console.log(event.dataTransfer.files);
			this.droppingFile = false;
		},

		doDropStudentFiles(event) {
			console.log("___FILE DROP___");
			console.log(event.dataTransfer.files);
			_.each(event.dataTransfer.files, file => {
				this.importStudentRows(file);
			});
			this.droppingFile = false;
		},

		validateStudents(newStudents) {
			this.clearEmptyStudentRows();
			let students = _.cloneDeep(this.addingStudents);
			if (newStudents && newStudents.length) {
				students = students.concat(newStudents);
			}
			_.each(students, s => {
				s.grade_id = s.grade && s.grade.id;
			});

			let did = this.classObj.district_id;
			this.validating = true;
			this.allValid = true;
			StudentService.getStudentMatches(students, did).then(resp => {
				this.addingStudents = [];
				_.each(resp.data, matchStat => {
					let student = matchStat.student;
					let existing = _.find(this.students, {
						id: student.id
					});
					if (existing) {
						student.exists = true;
					}
					student.match = matchStat.match;
					if (matchStat.partial_name) {
						student.partial_name = matchStat.partial_name;
						let existing = _.find(this.students, {
							id: student.partial_name.id
						});
						if (existing) {
							student.partial_name.exists = true;
						}
					}
					if (matchStat.partial_id) {
						student.partial_id = matchStat.partial_id;
						console.log("partial id", student);
						this.allValid = false;
					}
					student.grade = _.find(this.grades, {
						id: student.grade_id
					});

					if (!student.ref_id || student.ref_id == "") {
						student.error = "You must enter a student ID";
						console.log("no id", student);
						this.allValid = false;
					} else if (this.district.id_regex && !this.district.id_regex.exec(student.ref_id)) {
						student.error = `Student ID does not match this district's required pattern ("${this.district.validation_pattern}")`;
						console.log("invalid id", student);
						this.allValid = false;
					} else if (!student.first_name || !student.last_name) {
						student.error = "You must enter a name";
						console.log("no name", student);
						this.allValid = false;
					} else if (this.district.require_emails && !student.email) {
						student.error = "You must enter an email address";
						console.log("email address", student);
						this.allValid = false;
					}

					this.clearEmptyStudentRows();
					this.addingStudents.push(student);
					this.validating = false;
					this.validated = true;
				});
			});
		},

		convertToNewStudent(student) {
			delete student.id;
			delete student.exists;
			delete student.match;

			this.validated = false;
			this.allValid = false;
			this.$forceUpdate();
		},

		convertToExistingStudent(student, matchedStudent) {
			student.first_name = matchedStudent.first_name;
			student.last_name = matchedStudent.last_name;
			student.ref_id = matchedStudent.ref_id;
			student.grade_id = matchedStudent.grade_id;
			student.grade = _.find(this.grades, {
				id: student.grade_id
			});
			student.id = matchedStudent.id;
			delete student.partial_name;
			delete student.partial_id;

			this.validated = false;
			this.allValid = false;
		},

		changedStudentName(student) {
			delete student.partial_id;
			this.changedStudent(student);
		},

		changedStudentID(student) {
			delete student.partial_name;
			this.changedStudent(student);
		},

		changedStudent(student) {
			delete student.match;
			delete student.error;
			this.validated = false;
			this.allValid = false;
		},

		hasID(student) {
			if (student.id && student.id != "") {
				return true;
			} else {
				return false;
			}
		},

		hideAddModal() {
			this.addingStudents = [{}];
			this.validated = false;
			this.allValid = false;

			$("#addStudentModal").modal("toggle");
		},

		click(id) {
			console.log("click the thing");
			var el = document.getElementById(id);
			if (el) {
				el.value = "";
				el.click();
			}
		},

		openEditStudentModal(student) {
			this.editStudent = _.cloneDeep(student);

			$("#editStudentModal").modal();
		},

		saveEditStudent() {
			this.editSaving = true;
			StudentService.saveStudent(this.editStudent)
				.then(resp => {
					this.editSaving = false;
					Notie.info("Student updated");
					this.loadData().then(() => {
						this.hideEditStudentModal();
					});
				})
				.catch(err => {
					this.editSaving = false;
					console.log(err);
					Notie.error("Failed to update student information", err);
				});
		},

		hideEditStudentModal() {
			$("#editStudentModal").modal("toggle");
		},

		attemptRemoveStudent(student) {
			this.removingStudent = student;
			$("#removeStudentModal").modal();
		},

		doRemoveStudent() {
			this.removing = true;
			StudentService.removeStudentFromClass(this.removingStudent.id, this.classObj.id)
				.then(resp => {
					Notie.info(`${this.removingStudent.full_name} removed from class`);
					this.loadData().then(() => {
						this.removing = false;
						this.hideRemoveStudentModal();
					});
				})
				.catch(err => {
					this.removing = false;
					console.log(err);
					Notie.error("Failed to remove student from class", err);
				});
		},

		hideRemoveStudentModal() {
			$("#removeStudentModal").modal("toggle");
		},

		viewResource(itemID, resource) {
			if (resource.type == 1) {
				ResourceService.viewResource(itemID, resource);
			} else if (resource.type == 2) {
				ResourceService.viewExternalResource(resource.path);
			}
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/vues/Classes/ClassQR.vue